import { render, staticRenderFns } from "./orders-tab.vue?vue&type=template&id=583180a8&scoped=true&"
import script from "./orders-tab.vue?vue&type=script&lang=js&"
export * from "./orders-tab.vue?vue&type=script&lang=js&"
import style0 from "./orders-tab.vue?vue&type=style&index=0&id=583180a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583180a8",
  null
  
)

export default component.exports